import {
    Component,
    OnDestroy,
    AfterViewInit
} from '@angular/core';
import {
    Api
} from '../../providers';
import {
    ModalController
} from 'ionic-angular';
import {
    CARRITO_DETALLE_PAGE
} from '../../pages/pages.constants';

@Component({
    selector: 'carrito-boton',
    templateUrl: 'carrito-boton.html'
})
export class CarritoBotonComponent implements AfterViewInit, OnDestroy {
    public carrito: Array < any > = [];

    constructor(private _api: Api, private _modal: ModalController) {}

    ngAfterViewInit(): void {
        this._api.isLoggedIn().subscribe((user) => {
            this.initCarrito();
        }, err => {})
    }

    initCarrito() {
        this._api.get('carrito').subscribe((carritos: Array < any > ) => {
            this.carrito = carritos;
            this._api.subscribeCollection('carrito', this.carrito);
        }, err => {});
    }

    ngOnDestroy(): void {
        this._api.unsubscribeCollection('carritos');
    }

    getTotal(): Number {
        return this.carrito.length;
    }

    abrirCarrito() {
        this._modal.create(CARRITO_DETALLE_PAGE).present();
    }
}


// WEBPACK FOOTER //
// ./src/components/carrito-boton/carrito-boton.ts